import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { SegmentedOptions } from 'ui';
import type { Mode } from '../../../../types';

export const useGetModeOptions = (): SegmentedOptions<Mode> => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('Day'), value: 'day' as const },
      { label: t('Week'), value: 'week' as const },
      { label: t('Month'), value: 'month' as const },
    ],
    [t],
  );
};
